import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Share = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 5.19a2.52 2.52 0 0 1-4.076 1.983L8.66 11.325a2.522 2.522 0 0 1 0 1.35l6.076 4.027a2.52 2.52 0 1 1-.745 1.427l-6.229-4.127a2.52 2.52 0 1 1 0-4.003l6.283-4.163A2.52 2.52 0 1 1 19 5.19Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Share
